import React from 'react';
import ForgotPasswordForm from './forgotPasswordForm';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import * as adminActions from '../actions/admin';
import withRouter from '../utils/withRouter';

class ForgotForwardPage extends React.Component {

  constructor(props) {
    super(props);

    // set the initial component state
    this.state = {
      errors: {
        email: '',
        client: ''
      },
      email: '',
      client: ''
    };

    this.processForm = this.processForm.bind(this);
    this.UpdateValue = this.UpdateValue.bind(this);
  }

  processForm(event) {
    // prevent default action. in this case, action is the form submission event
    event.preventDefault();
    var that = this;
   
    this.props.actions.forgotPassword(this.state.email, this.state.client)
    .then(res => {
    
      that.props.navigate('/');
  
    })
    .catch(err =>{
                alert(err);
            })
  }

  UpdateValue(event) {
   
    var field = event.target.name;

    this.setState({
      [field]: event.target.value
    });
  }

  
  render() {
    return (
      <ForgotPasswordForm
        onSubmit={this.processForm}
        onChange={this.UpdateValue}
        errors={this.state.errors}
        email={this.state.email}
        client={this.state.client}
      />
    );
  }

}


function mapStateToProps(state) { 
    return {loggedIn: state.loggedIn}
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(adminActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotForwardPage));